var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0244141H513V342.017H0V0.0244141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0244141H513V114.022H0V0.0244141ZM0 228.02H513V342.017H0V228.02Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 129.387C233.506 129.387 214.866 148.026 214.866 171.021C214.866 194.016 233.505 212.655 256.5 212.655C279.494 212.655 298.134 194.016 298.134 171.021C298.134 148.026 279.494 129.387 256.5 129.387ZM256.5 194.812C243.36 194.812 232.708 184.16 232.708 171.021C232.708 157.881 243.36 147.23 256.5 147.23C269.639 147.23 280.291 157.881 280.291 171.021C280.291 184.16 269.639 194.812 256.5 194.812Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.103 176.968L256.5 171.021L235.897 176.968L229.028 188.864H283.971L277.103 176.968Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 141.283L242.764 165.074L256.5 171.021L270.236 165.074L256.5 141.283Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.897 176.968H277.103L270.236 165.073H242.764L235.897 176.968Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.0205078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNi);
export default __webpack_public_path__ + "static/media/NI.38093920c8c85ad6a2a423f330aec7ff.svg";
export { ForwardRef as ReactComponent };